import React from "react";
import { COMPONENT_TYPES } from "@/components/PageCluster/helpers/componentTypes";
import { COMPONENT_TYPES as COMMON_COMPONENT_TYPES } from "@/helpers/constants";
import FAQ from "@/components/FAQ";
import { ClusterApiResponse } from "@/components/PageCluster/api/interface";
import { useAppSelector } from "@/redux/hooks";
import clusterDataSelector from "@/components/PageCluster/redux/selectors/clusterData";
import userAgentSelector from "@/components/PageCluster/redux/selectors/userAgent";
import ArticleComponent from "@/components/ArticleComponent";
import TopTips from "@/components/PagePiller/components/TopTips";
import PageIndex from "@/components/PagePiller/components/PageIndex";
import ContentImageDescComponent from "@/components/PagePiller/components/ContentImageDesc";
import QuotesCards from "@/components/QuotesCard";
import VideoWidgetComponent from "@/components/PagePiller/components/VideoWidget";
import ClusterActionCardsComponent from "@/components/PagePiller/components/ClusterActionCards";
import ClusterWeekSelection from "@/components/PageCluster/components/ClusterWeekSelection";
import ShoppingComponent from "@/components/ShoppingComponent";
import DoctorsWidget from "@/components/DoctorsWidget";
import DiagnosticsWidget from "@/components/DiagnosticsWidget";
import styles from "../../PageCluster.module.scss";

const ComponentMapping = (props) => {
  const { data, clusterSlug, extraData, index } = props;
  const { registerRef, indexContent, elementRefs, productInfo, currentSpeciality, doctorsArray, diagnostics } =
    extraData;
  const componentType = data?.ComponentType;
  const clusterData: ClusterApiResponse = useAppSelector(clusterDataSelector);
  const userAgent = useAppSelector(userAgentSelector);
  const clusterDetails = clusterData?.data?.[0]?.attributes;
  const categorySlug = clusterDetails?.Category?.data?.attributes?.Slug;
  const pillarSlug = clusterDetails?.Pillar?.data?.attributes?.Slug;

  switch (componentType) {
    case COMPONENT_TYPES.Index:
      return <PageIndex data={indexContent} elementRefs={elementRefs} userAgent={userAgent} />;
    case COMPONENT_TYPES.ArticlesWithTagSlider:
      return (
        <ArticleComponent
          registerRef={registerRef}
          data={data}
          clusterSlug={clusterSlug}
          userAgent={userAgent}
          categorySlug={categorySlug}
          pillarSlug={pillarSlug}
          desktopItems={3}
          assetPosition={index + 1}
        />
      );
    case COMPONENT_TYPES.FaqListWithTitle:
      return <FAQ data={data} />;
    case COMPONENT_TYPES.ContentImageDesc:
      return <ContentImageDescComponent registerRef={registerRef} data={data} userAgent={userAgent} />;
    case COMPONENT_TYPES.TopTips:
      return <TopTips registerRef={registerRef} data={data} userAgent={userAgent} />;
    case COMPONENT_TYPES.BannerWithImage:
      return <ClusterWeekSelection data={data} userAgent={userAgent} clusterSlug={clusterSlug} />;
    case COMPONENT_TYPES.Quote:
      return (
        <div className={` ${styles.quoteWrap} spacingBetweenSections`}>
          <QuotesCards data={data} />
        </div>
      );
    case COMPONENT_TYPES.VideoWidget2:
      return <VideoWidgetComponent data={data} userAgent={userAgent} />;
    case COMPONENT_TYPES.ClusterActionCards:
      return <ClusterActionCardsComponent data={data} userAgent={userAgent} assetPosition={index + 1} />;
    case COMPONENT_TYPES.ShopByCatSlider:
      return <ShoppingComponent data={data} productInfo={productInfo} userAgent={userAgent} />;
    case COMMON_COMPONENT_TYPES.DoctorConsult:
      return (
        <DoctorsWidget
          data={data}
          userAgent={userAgent}
          currentSpeciality={currentSpeciality}
          doctors={doctorsArray}
          utm_medium="cluster-page"
        />
      );
    case COMMON_COMPONENT_TYPES.LabTest:
      return (
        <div className="spacingBetweenSections">
          <DiagnosticsWidget data={data} userAgent={userAgent} diagnostics={diagnostics} utm_medium="cluster-page" />
        </div>
      );
    default:
      return <></>;
  }
};

export default ComponentMapping;
